
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';



@Injectable({
    providedIn: 'root'
  })
export class UserService {

    constructor(
        private http: HttpClient,
        private router: Router
    ) {
    }
    

    updateUserInfo(userId, data) {
        return this.http.put(`/api/v1/users/${userId}`, data);
    }
    getUserInfo(userId) {
        return this.http.get(`/api/v1/users/${userId}`);
    }

    changePassword(userId, data) {
        return this.http.put(`/api/v1/users/${userId}/change-password`, data);

    }
    closeAccount(userId) {
        return this.http.put(`/api/v1/users/${userId}/close-account`, {});
    }
    sendFeedback(userId, data) {
        return this.http.post(`/api/v1/users/${userId}/feedback`, data);
    }


    
}
